<template>
  <v-footer app id="app-core-footer" style="height: 45px;" color="white" class="pa-0 pt-1">
    <v-row align="center" no-gutters>
      <v-col class="text-center mb-sm-0 mb-5" cols="auto">
        <a
          href="https://releasenotes.atlon.ch/versions/doc-ecm"
          class="mr-0"
          rel="noopener"
          target="_blank"
          v-text="appVersionText"
          v-bind:style="{ color: darkTheme ? '#FFFFFF' : '#3c4858' }"
        />
      </v-col>
      <v-col
        v-for="(link, i) in links"
        :key="i"
        class="text-center mb-sm-0 mb-5"
        cols="auto"
      >
        <a
          v-show="link.href != '#'"
          :href="link.href"
          class="mr-0"
          rel="noopener"
          :target="link.target"
          v-text="link.text"
          v-bind:style="{ color: darkTheme ? '#FFFFFF' : '#3c4858' }"
        />
        <span
          v-show="link.href == '#'"
          class="mr-0"
          rel="noopener"
          v-text="link.text"
        />
      </v-col>

      <v-spacer class="hidden-sm-and-down" />

      <v-col cols="12" md="auto" class="text-center">
        <a
          v-bind:style="{ color: darkTheme ? '#FFFFFF' : '#3c4858' }"
          target="_blank"
          rel="noopener"
          v-text="site.text"
          :href="site.url"
        />
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
    name: 'AppCoreFooter',
    async created() {
        await this.getAppVersion();
    },
    mounted() {
        if (this.$store.getters['theme/footer']) {
            this.links = this.$store.getters['theme/footer'].items;
            this.site = this.$store.getters['theme/footer'].site;
            this.darkTheme = this.$store.getters['theme/dark'];
        }
    },
    data: () => ({
        links: [],
        site: '',
        prop1: '',
        darkTheme: false,
        appVersion: '',
        currYear: new Date().getFullYear(),
    }),
    computed: {
        appVersionText() {
            return `${this.appVersion} | COPYRIGHT © ${this.currYear}`;
        },
    },
    methods: {
        async getAppVersion() {
            if (!this.$store.getters['account/apiUrl']) {
                var config = await fetch('/config.json').then((response) =>
                    response.json()
                );
                this.$store.dispatch('account/setApiUrl', config.apiUrl);
            }
            const url = `${this.$store.getters['account/apiUrl']}/api/app-version/new`;
            this.appVersion = await fetch(url).then((response) => response.json());
        },
    },
};
</script>

<style lang="sass">
#app-core-footer
  z-index: 1

  a
    font-size: 0.825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase

</style>
